import { Box, Button, Modal } from '@mui/material';
import React from 'react';

const ConfirmModal = ({ title, text, isOpen, onClose, confirmFunction, children }) => {
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'var(--color-white)',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    minWidth: 300,
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => onClose(false)}
    >
      <Box sx={modalStyle}>
        <h2>{title}</h2>
         <p style={{fontSize: '0.8rem'}}>{text}</p>
        {children && children}
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={() => onClose(false)} color="error">Cancelar</Button>
          <Button
            onClick={() => confirmFunction()}
            color="primary"
            variant="contained"
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
